import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Building2, Users, HeartPulse, Wallet, BedDouble, Ticket } from "lucide-react";
import { api } from "@/lib/api";
import { Loader } from "@/components/Loader";
import { money } from "@/lib/format";

function SACard({ icon: Icon, label, value, tone = "blue", i }) {
  const tones = { blue: "bg-teal-500/15 text-teal-400", emerald: "bg-emerald-500/15 text-emerald-400", amber: "bg-amber-500/15 text-amber-400", indigo: "bg-indigo-500/15 text-indigo-400", rose: "bg-rose-500/15 text-rose-400" };
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5" style={{ animationDelay: `${i * 40}ms` }} data-testid={`sa-stat-${label.toLowerCase()}`}>
      <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${tones[tone]}`}><Icon className="h-5 w-5" /></div>
      <div className="mt-4 font-display text-3xl font-extrabold text-white">{value}</div>
      <div className="mt-1 text-xs font-medium uppercase tracking-wider text-slate-400">{label}</div>
    </div>
  );
}

export function SAOverview() {
  const { data, isLoading } = useQuery({ queryKey: ["sa-overview"], queryFn: async () => (await api.get("/superadmin/overview")).data });
  if (isLoading) return <Loader full />;
  const cur = data?.currency || "NGN";
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-white sm:text-3xl">Platform Overview</h1>
      <p className="mt-1 text-sm text-slate-400">Tenant and revenue telemetry across all FHAPAS organisations.</p>
      <div className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-6">
        <SACard icon={Building2} label="Organisations" value={data?.organisations ?? 0} tone="blue" i={0} />
        <SACard icon={Users} label="Users" value={data?.users ?? 0} tone="indigo" i={1} />
        <SACard icon={HeartPulse} label="Patients" value={data?.patients ?? 0} tone="emerald" i={2} />
        <SACard icon={Wallet} label="Revenue" value={money(data?.revenue, cur)} tone="emerald" i={3} />
        <SACard icon={BedDouble} label="Admissions" value={data?.active_admissions ?? 0} tone="amber" i={4} />
        <SACard icon={Ticket} label="Active Promos" value={data?.active_promos ?? 0} tone="rose" i={5} />
      </div>
    </div>
  );
}
